/* global axios */
import ApiClient from './ApiClient';

class AiOnboardingAPI extends ApiClient {
  constructor() {
    super('ai_onboarding', { accountScoped: true });
  }

  /**
   * Get current onboarding progress
   * GET /api/v1/accounts/:accountId/ai_onboarding/progress
   */
  getProgress() {
    return axios.get(`${this.url}/progress`);
  }

  /**
   * Save onboarding progress
   * POST /api/v1/accounts/:accountId/ai_onboarding/save_progress
   * @param {Object} data - { account_id, state }
   */
  saveProgress(data) {
    return axios.post(`${this.url}/save_progress`, data);
  }

  /**
   * Resume onboarding from saved state
   * GET /api/v1/accounts/:accountId/ai_onboarding/resume
   */
  resume() {
    return axios.get(`${this.url}/resume`);
  }

  /**
   * Test AI provider connection
   * POST /api/v1/accounts/:accountId/ai_onboarding/test_connection
   * @param {Object} data - { provider, api_key, model, api_url }
   */
  testConnection(data) {
    return axios.post(`${this.url}/test_connection`, data);
  }

  /**
   * Generate AI content (FAQs, rules, etc.)
   * POST /api/v1/accounts/:accountId/ai_onboarding/generate
   * @param {Object} data - { provider_setup, bot_profile, conversational_answers, bot_modes }
   */
  generate(data) {
    return axios.post(`${this.url}/generate`, data);
  }

  /**
   * Apply generated configuration to account
   * POST /api/v1/accounts/:accountId/ai_onboarding/apply
   * @param {Object} data - { configuration }
   */
  apply(data) {
    return axios.post(`${this.url}/apply`, data);
  }

  /**
   * Test chat with current configuration
   * POST /api/v1/accounts/:accountId/ai_onboarding/test_chat
   * @param {Object} data - { message, context }
   */
  testChat(data) {
    return axios.post(`${this.url}/test_chat`, data);
  }

  /**
   * Get remaining test chat quota
   * GET /api/v1/accounts/:accountId/ai_onboarding/test_chat_quota
   */
  getTestChatQuota() {
    return axios.get(`${this.url}/test_chat_quota`);
  }

  /**
   * Demo chat với AI thật (tối đa 5 tin nhắn)
   * POST /api/v1/accounts/:accountId/ai_onboarding/demo_chat
   * @param {Object} data - { message, provider_setup }
   */
  demoChat(data) {
    return axios.post(`${this.url}/demo_chat`, data);
  }

  /**
   * Generate questions bằng AI
   * POST /api/v1/accounts/:accountId/ai_onboarding/generate_questions
   * @param {Object} data - { bot_profile, bot_modes, provider_setup }
   */
  generateQuestions(data) {
    return axios.post(`${this.url}/generate_questions`, data);
  }
}

export default new AiOnboardingAPI();
